module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-color__c-alpha"
  }, [_c('div', {
    staticClass: "vue-color__c-alpha__checkboard-wrap"
  }, [_c('checkboard')], 1), _vm._v(" "), _c('div', {
    staticClass: "vue-color__c-alpha__gradient",
    style: ({
      background: _vm.gradientColor
    })
  }), _vm._v(" "), _c('div', {
    ref: "container",
    staticClass: "vue-color__c-alpha__container",
    on: {
      "mousedown": _vm.handleMouseDown,
      "touchmove": _vm.handleChange,
      "touchstart": _vm.handleChange
    }
  }, [_c('div', {
    staticClass: "vue-color__c-alpha__pointer",
    style: ({
      left: _vm.colors.a * 100 + '%'
    })
  }, [_c('div', {
    staticClass: "vue-color__c-alpha__picker"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ab2f56b8!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-color/src/components/common/Alpha.vue
// module id = 348
// module chunks = 1